const getByPath = (obj, path) => {
  if (!path || path.length === 0) return obj;
  return path.reduce((acc, key) => {
    if (acc && typeof acc === "object" && key in acc) return acc[key];
    return undefined;
  }, obj);
};

export const getFileUploadErrorMessage = (error) => {
  const errorData = getByPath(error, ["response", "data", "error"]);
  const details = getByPath(errorData, ["details"]);

  const { pwdProtectedFilenames, malformedFilenames } = (
    Array.isArray(details) ? [...details] : [details]
  ).reduce(
    (acc, failedFile) => {
      if (failedFile?.message.includes("password_protected"))
        acc.pwdProtectedFilenames.push(failedFile.filename);

      if (failedFile?.message.includes("malformed_pdf"))
        acc.malformedFilenames.push(failedFile.filename);

      return acc;
    },
    {
      pwdProtectedFilenames: [],
      malformedFilenames: []
    }
  );

  if (pwdProtectedFilenames.length || malformedFilenames.length) {
    const pwdProtectedErrorMessage = getPwdProtectedErrorMessage(
      pwdProtectedFilenames
    );
    const malformedFilesErrorMessage =
      getMalformedFilesErrorMessage(malformedFilenames);

    return [pwdProtectedErrorMessage, malformedFilesErrorMessage]
      .filter(Boolean)
      .join(" ");
  }

  return null;
};

const getPwdProtectedErrorMessage = (filenames) => {
  switch (filenames.length) {
    case 0:
      return "";
    case 1:
      return `Document "${filenames[0]}" is a password-protected PDF and cannot be processed. Please upload a version that does not require a password.`;
    default: {
      const joinedFileNames = filenames.join(", ");

      return `Documents "${joinedFileNames}" are password-protected PDFs and cannot be processed. Please upload versions that do not require a password.`;
    }
  }
};

const getMalformedFilesErrorMessage = (filenames) => {
  switch (filenames.length) {
    case 0:
      return "";
    case 1:
      return `Document "${filenames[0]}" is malformed and cannot be processed. Please generate and upload a new document to try to resolve this error.`;
    default: {
      const joinedFileNames = filenames.join(", ");

      return `Documents "${joinedFileNames}" are malformed and cannot be processed. Please generate and upload new documents to try to resolve this error.`;
    }
  }
};
